"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordToPairs = recordToPairs;
exports.pairsToRecord = pairsToRecord;
exports.mapRecord = mapRecord;
const arrays_1 = require("./arrays");
/**
 * Translates a given record into an array of key,value pairs. Unlike Object.entires() it correctly preserves the types
 * of the keys and the values.
 */
function recordToPairs(record) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const pairs = Object.entries(record);
    return (0, arrays_1.sortBy)(pairs, ([k]) => k);
}
/**
 * Translates a given array of key,value pairs into a record. Unlike Object.fromEntries() it correctly preserves the
 * types of the keys and the values.
 */
function pairsToRecord(pairs) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const ret = {};
    for (const [k, v] of Array.from(pairs)) {
        ret[k] = v;
    }
    return ret;
}
function mapRecord(record, f) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const ret = {};
    for (const [k, v] of recordToPairs(record)) {
        const mapped = f([k, v]);
        if (mapped) {
            const [k2, v2] = mapped;
            ret[k2] = v2;
        }
    }
    return ret;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVjb3Jkcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWNvcmRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBTUEsc0NBSUM7QUFNRCxzQ0FPQztBQUVELDhCQWNDO0FBdkNELHFDQUFpQztBQUVqQzs7O0dBR0c7QUFDSCxTQUFnQixhQUFhLENBQXNCLE1BQW9CO0lBQ3JFLHlFQUF5RTtJQUN6RSxNQUFNLEtBQUssR0FBRyxNQUFNLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBYSxDQUFBO0lBQ2hELE9BQU8sSUFBQSxlQUFNLEVBQUMsS0FBSyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUE7QUFDbEMsQ0FBQztBQUVEOzs7R0FHRztBQUNILFNBQWdCLGFBQWEsQ0FBc0IsS0FBMkM7SUFDNUYseUVBQXlFO0lBQ3pFLE1BQU0sR0FBRyxHQUFpQixFQUFrQixDQUFBO0lBQzVDLEtBQUssTUFBTSxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsSUFBSSxLQUFLLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUM7UUFDdkMsR0FBRyxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQTtJQUNaLENBQUM7SUFDRCxPQUFPLEdBQUcsQ0FBQTtBQUNaLENBQUM7QUFFRCxTQUFnQixTQUFTLENBQ3ZCLE1BQW9CLEVBQ3BCLENBQXNDO0lBRXRDLHlFQUF5RTtJQUN6RSxNQUFNLEdBQUcsR0FBRyxFQUFvQixDQUFBO0lBQ2hDLEtBQUssTUFBTSxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsSUFBSSxhQUFhLENBQUMsTUFBTSxDQUFDLEVBQUUsQ0FBQztRQUMzQyxNQUFNLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQTtRQUN4QixJQUFJLE1BQU0sRUFBRSxDQUFDO1lBQ1gsTUFBTSxDQUFDLEVBQUUsRUFBRSxFQUFFLENBQUMsR0FBRyxNQUFNLENBQUE7WUFDdkIsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLEVBQUUsQ0FBQTtRQUNkLENBQUM7SUFDSCxDQUFDO0lBQ0QsT0FBTyxHQUFHLENBQUE7QUFDWixDQUFDIn0=